import type { WizardFeatureContext } from '@/components/_championship/forms/types/wizard'

const WIZARD_FLOW_OPTIONS_SUFFIX = 'wizard_flow_options'

function getFlowOptionsStorageKey(championshipId: string): string {
  return `championship_${championshipId}_${WIZARD_FLOW_OPTIONS_SUFFIX}`
}

function isClient(): boolean {
  return typeof window !== 'undefined'
}

export function getWizardFlowOptions(
  championshipId: string,
): WizardFeatureContext | null {
  if (!isClient() || !championshipId) return null

  try {
    const rawValue = window.localStorage.getItem(
      getFlowOptionsStorageKey(championshipId),
    )
    if (!rawValue) return null

    const parsed = JSON.parse(rawValue) as WizardFeatureContext
    return {
      teamsEnabled: parsed.teamsEnabled !== false,
      rulesEnabled: parsed.rulesEnabled !== false,
      tiersAndSplitsEnabled: parsed.tiersAndSplitsEnabled !== false,
      applicationFormEnabled: parsed.applicationFormEnabled !== false,
      serverInfoEnabled: parsed.serverInfoEnabled !== false,
      dropRoundsEnabled: parsed.dropRoundsEnabled !== false,
    }
  } catch {
    return null
  }
}

export function setWizardFlowOptions(
  championshipId: string,
  context: WizardFeatureContext,
): void {
  if (!isClient() || !championshipId) return

  window.localStorage.setItem(
    getFlowOptionsStorageKey(championshipId),
    JSON.stringify({
      teamsEnabled: context.teamsEnabled !== false,
      rulesEnabled: context.rulesEnabled !== false,
      tiersAndSplitsEnabled: context.tiersAndSplitsEnabled !== false,
      applicationFormEnabled: context.applicationFormEnabled !== false,
      serverInfoEnabled: context.serverInfoEnabled !== false,
      dropRoundsEnabled: context.dropRoundsEnabled !== false,
    }),
  )
}

export function clearWizardFlowOptions(championshipId: string): void {
  if (!isClient() || !championshipId) return

  window.localStorage.removeItem(getFlowOptionsStorageKey(championshipId))
}

export function getWizardFlowOptionsOrDefault(
  championshipId: string,
  fallbackContext: WizardFeatureContext,
): WizardFeatureContext {
  return getWizardFlowOptions(championshipId) ?? fallbackContext
}
